// extracted by mini-css-extract-plugin
export var wrap = "NumericInput-module--wrap--XH5u9";
export var input = "NumericInput-module--input--VBjju";
export var decrement = "NumericInput-module--decrement--SqB37";
export var increment = "NumericInput-module--increment--qJ86U";